"use client"

import { useState, useEffect } from "react"
import "../styles/award-section.css"
import aw1 from "../assets/images/aw1.png"
import aw2 from "../assets/images/aw2.png"
import aw3 from "../assets/images/aw3.png"
import aw7 from "../assets/images/aw7.webp"

export default function AwardSection() {
    return (
        <section className="empowercontainer" id="">
            <div>
                <div className="emppoerHeading">
                    <h2> Awards & Recognition</h2>
                    <p>
                        Celebrating excellence in natural products and sustainable practices
                    </p>
                </div>

                <div className="grid-flex">
                    <div
                        className="col col-image"

                    >
                        <img src={aw1} alt="aw1" />
                    </div>
                    <div className="col col-text">
                        <div className="Aligner-item">
                            <h2>Icon of Indian Business Award - 2022</h2>
                            <p>
                                Our Founder Harshith S V  proud to be honored with the prestigious Icon of Indian Business – Best Young Innovator Award in the Food Products category, recognizing our commitment to innovation, quality, and excellence in the food industry.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="grid-flex">
                    <div
                        className="col col-image"

                    >       <img src={aw2} alt="aw1" /></div>
                    <div className="col col-text col-left">
                        <div className="Aligner-item">
                            <h2>Karnataka Business Awards - 2022</h2>                             
                            <p>
                                Awarded Best Coconut Chips Manufacturer by the Karnataka Business Awards, honoring our commitment to crafting premium, natural snacks with a focus on quality and innovation. </p>
                        </div>
                    </div>
                </div>

                <div className="grid-flex">
                    <div
                        className="col col-image"

                    >
                        <img src={aw3} alt="aw1" />
                    </div>
                    <div className="col col-text">
                        <div className="Aligner-item">
                            <h2>Certificate of Nomination</h2>
                           <p>
                                Haronics Consumer Products LLP has been nominated for the India 5000 Best MSME Awards, recognizing our commitment to quality excellence and outstanding business practices.
                            </p>
                        </div>
                    </div>
                </div>
                <div className="grid-flex">

                    <div className="col col-text">
                        <div className="Aligner-item">
                            <h2>Certificate of Recognition by Startup India</h2>
                            
                            <p>
                               Haronics Consumer Products LLP is proud to be officially recognized by the Department for Promotion of Industry and Internal Trade (DPIIT) under the Startup India initiative, acknowledging our contribution to innovation and entrepreneurship.
                            </p>
                        </div>
                    </div>
                    <div
                        className="col col-image"
                    >
                        <img src={aw7} alt="aw1" />
                    </div>
                </div>
            </div>
        </section>
    )
}
